import LocationImportTemplate from '../../../components/5templates/LocationImportTemplate'
import DataImportFormTabs from '../../../components/3modules/DataImportFormTabs'
import { useNavigate } from 'react-router-dom'

const ImportLocationForm = () => {
    const navigate = useNavigate()
    const goToPreviousPage = () => {
        navigate('/adminDashboard')
    }
    const goToNextPage = () => {
        navigate('/addLocation/people')
    }

    return(
        <DataImportFormTabs flow={'addLocation'}>
                <LocationImportTemplate goToPreviousPage={goToPreviousPage}
                                        goToNextPage={goToNextPage}
                />
        </DataImportFormTabs>
    )
}

export default ImportLocationForm
